import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class Tooltip extends React.Component {
  constructor(props) {
    super(props)

    this.config = {
      types : [ 
        {
          title: 'top',
          isDefault: true,
        },
        'right',
        'bottom', 
        'left'
      ],
      modifiers : [],
      states :[]
    }
  }
  
  render() {
    const { isVisible, ...rest } = this.props
    return <div {...rest} className={resolveProps(this.props, this.config, 'Tooltip') } style={{display:isVisible?'inline-flex':'none'}}>
      <p className="mdn-Text mdn-Text--body mdn-Text--inverse">{this.props.children}</p>
    </div>
  }
}

Tooltip.propTypes = {
  children : PropTypes.node,
  iconSrc : PropTypes.string,
  text : PropTypes.string,
  vertical : PropTypes.bool
}